<div class="form-fill-container">
  <!-- Reactive form fields -->
  <div [formGroup]="formGroup">
    <div *ngFor="let field of fields" class="form-field-row">

      <!-- Skip table fields here — rendered separately below -->
      <ng-container *ngIf="field.Field_Type !== 'table'">

        <!-- Section Separator -->
        <ng-container *ngIf="field.Field_Type === 'section'">
          <div class="form-section">
            <h3>{{ field.Label }}</h3>
            <hr />
          </div>
        </ng-container>

        <!-- Regular Fields -->
        <ng-container *ngIf="field.Field_Type !== 'section'">
          <div class="Content-grid-2">
            <div class="Text-icon">
              {{ field.Label }}
              <span *ngIf="field.Required" class="required-mark">*</span>
            </div>
            <div class="Container-input">

              <!-- Text Short -->
              <input *ngIf="field.Field_Type === 'text_short'"
                pInputText
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [placeholder]="field.Placeholder || ''"
                class="input-text" />

              <!-- Text Long -->
              <textarea *ngIf="field.Field_Type === 'text_long'"
                pTextarea
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [placeholder]="field.Placeholder || ''"
                rows="3"
                class="input-textarea">
              </textarea>

              <!-- Number -->
              <p-inputNumber *ngIf="field.Field_Type === 'number'"
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [placeholder]="field.Placeholder || ''"
                mode="decimal">
              </p-inputNumber>

              <!-- Date -->
              <p-datePicker *ngIf="field.Field_Type === 'date'"
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [placeholder]="field.Placeholder || 'Seleccione fecha'"
                dateFormat="dd/mm/yy"
                [showIcon]="true">
              </p-datePicker>

              <!-- Select -->
              <p-select *ngIf="field.Field_Type === 'select'"
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [options]="getOptions(field)"
                [placeholder]="field.Placeholder || 'Seleccione una opcion'">
              </p-select>

              <!-- Multi Select -->
              <p-multiSelect *ngIf="field.Field_Type === 'multi_select'"
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)"
                [options]="getOptions(field)"
                [placeholder]="field.Placeholder || 'Seleccione opciones'">
              </p-multiSelect>

              <!-- Boolean -->
              <p-toggleswitch *ngIf="field.Field_Type === 'boolean'"
                [formControlName]="'field_' + (field.UI_ID || field.ID || field.Field_Order)">
              </p-toggleswitch>

              <!-- Email -->
              <input *ngIf="field.Field_Type === 'email'"
                type="email"
                pInputText
                [formControlName]="getFieldKey(field)"
                [placeholder]="field.Placeholder || 'correo@ejemplo.com'"
                class="input-text" />

              <!-- Phone -->
              <input *ngIf="field.Field_Type === 'phone'"
                type="tel"
                pInputText
                [formControlName]="getFieldKey(field)"
                [placeholder]="field.Placeholder || '+34 123 456 789'"
                class="input-text" />

              <!-- URL -->
              <input *ngIf="field.Field_Type === 'url'"
                type="url"
                pInputText
                [formControlName]="getFieldKey(field)"
                [placeholder]="field.Placeholder || 'https://ejemplo.com'"
                class="input-text" />

              <!-- Time -->
              <input *ngIf="field.Field_Type === 'time'"
                type="time"
                pInputText
                [formControlName]="getFieldKey(field)"
                class="input-text" />

              <!-- Checkbox List -->
              <div *ngIf="field.Field_Type === 'checkbox_list'" class="checkbox-list-group">
                <div *ngFor="let option of getOptions(field)" class="checkbox-item">
                  <input
                    type="checkbox"
                    [(ngModel)]="checkboxMap[getFieldKey(field) + '_' + option]"
                    [ngModelOptions]="{standalone: true}"
                    (change)="onCheckboxChange(field, option, $event)">
                  <label>{{ option }}</label>
                </div>
              </div>

              <!-- Rich Text -->
              <div *ngIf="field.Field_Type === 'rich_text'" class="rich-text-container">
                <textarea *ngIf="mode === 'fill'"
                  pTextarea
                  [formControlName]="getFieldKey(field)"
                  [placeholder]="field.Placeholder || 'Ingresa texto con formato'"
                  rows="4"
                  class="input-textarea">
                </textarea>
                <div *ngIf="mode !== 'fill'" class="rich-text-display" [innerHTML]="getFieldControl(field).value">
                </div>
              </div>

              <!-- QR Code -->
              <div *ngIf="field.Field_Type === 'qr_code'" class="qr-code-area">
                <ng-container *ngIf="mode === 'fill' && !getFieldControl(field).value">
                  <button type="button" class="btn-scan-qr" (click)="scanQRCode(field)">
                    <i class="fa-solid fa-qrcode"></i> Escanear Código QR
                  </button>
                  <input type="hidden"
                    [formControlName]="getFieldKey(field)" />
                </ng-container>
                <ng-container *ngIf="mode === 'preview' || mode === 'readonly' || (mode === 'fill' && getFieldControl(field).value)">
                  <div *ngIf="getFieldControl(field).value" class="generated-code-container">
                    <img [src]="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + getFieldControl(field).value" 
                         class="generated-qr" alt="QR Code" />
                    <span class="code-value-text">{{ getFieldControl(field).value }}</span>
                  </div>
                  
                  <div *ngIf="!getFieldControl(field).value && mode === 'preview'" class="field-preview-placeholder">
                    <i class="fa-solid fa-qrcode"></i>
                    <span>Código QR</span>
                  </div>
                  
                  <span *ngIf="!getFieldControl(field).value && mode === 'readonly'" class="sig-empty">Sin código QR</span>
                </ng-container>
              </div>

              <!-- Barcode -->
              <div *ngIf="field.Field_Type === 'barcode'" class="barcode-area">
                <ng-container *ngIf="mode === 'fill' && !getFieldControl(field).value">
                  <button type="button" class="btn-scan-barcode" (click)="scanBarcode(field)">
                    <i class="fa-solid fa-barcode"></i> Escanear Código de Barras
                  </button>
                  <input type="hidden"
                    [formControlName]="getFieldKey(field)" />
                </ng-container>
                <ng-container *ngIf="mode === 'preview' || mode === 'readonly' || (mode === 'fill' && getFieldControl(field).value)">
                  <div *ngIf="getFieldControl(field).value" class="generated-code-container">
                    <img [src]="'https://bwipjs-api.metafloor.com/?bcid=code128&text=' + getFieldControl(field).value + '&scale=2&rotate=N&includetext'" 
                         class="generated-barcode" alt="Barcode" />
                  </div>
                  
                  <div *ngIf="!getFieldControl(field).value && mode === 'preview'" class="field-preview-placeholder">
                    <i class="fa-solid fa-barcode"></i>
                    <span>Código de Barras</span>
                  </div>
                  
                  <span *ngIf="!getFieldControl(field).value && mode === 'readonly'" class="sig-empty">Sin código de barras</span>
                </ng-container>
              </div>

              <!-- Image Upload -->
              <div *ngIf="field.Field_Type === 'image'" class="file-upload-area">
                <ng-container *ngIf="!hasFile(field) && mode !== 'readonly'">
                  <label class="upload-dropzone upload-dropzone-image"
                    [attr.for]="'fileInput_' + (field.UI_ID || field.ID || field.Field_Order)">
                    <i class="fa-regular fa-image"></i>
                    <span>{{ field.Placeholder || 'Haz clic para subir una imagen' }}</span>
                    <small>PNG, JPG, GIF, WEBP</small>
                  </label>
                  <input type="file"
                    [id]="'fileInput_' + (field.UI_ID || field.ID || field.Field_Order)"
                    [accept]="getAcceptTypes(field)"
                    (change)="onFileSelect($event, field)"
                    class="file-input-hidden" />
                </ng-container>
                <ng-container *ngIf="hasFile(field)">
                  <div class="file-preview">
                    <img *ngIf="getPreview(field)" [src]="getPreview(field)" class="image-preview" alt="Preview" />
                    <div class="file-info">
                      <span class="file-name">{{ getFileName(field) }}</span>
                      <button *ngIf="mode !== 'readonly'" class="btn-remove-file" (click)="removeFile(field)">
                        <i class="fa-solid fa-xmark"></i> Quitar
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- File Upload (generic) -->
              <div *ngIf="field.Field_Type === 'file'" class="file-upload-area">
                <ng-container *ngIf="!hasFile(field) && mode !== 'readonly'">
                  <label class="upload-dropzone"
                    [attr.for]="'fileInput_' + (field.UI_ID || field.ID || field.Field_Order)">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                    <span>{{ field.Placeholder || 'Haz clic para subir un archivo' }}</span>
                  </label>
                  <input type="file"
                    [id]="'fileInput_' + (field.UI_ID || field.ID || field.Field_Order)"
                    [accept]="getAcceptTypes(field)"
                    (change)="onFileSelect($event, field)"
                    class="file-input-hidden" />

                </ng-container>
                <ng-container *ngIf="hasFile(field)">
                  <div class="file-preview">
                    <img *ngIf="getPreview(field)" [src]="getPreview(field)" class="image-preview" alt="Preview" />
                    <div *ngIf="!getPreview(field)" class="file-icon-preview">
                      <i class="fa-solid fa-file"></i>
                    </div>
                    <div class="file-info">
                      <span class="file-name">{{ getFileName(field) }}</span>
                      <button *ngIf="mode !== 'readonly'" class="btn-remove-file" (click)="removeFile(field)">
                        <i class="fa-solid fa-xmark"></i> Quitar
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>

              <!-- Signature -->
              <div *ngIf="field.Field_Type === 'signature'" class="signature-area">
                <ng-container *ngIf="mode === 'fill'">
                  <canvas
                    [id]="'sigCanvas_' + (field.UI_ID || field.ID || field.Field_Order)"
                    class="signature-canvas"
                    width="400" height="150"
                    (mousedown)="onSigStart($event, field)"
                    (mousemove)="onSigMove($event, field)"
                    (mouseup)="onSigEnd(field)"
                    (mouseleave)="onSigEnd(field)"
                    (touchstart)="onSigTouchStart($event, field)"
                    (touchmove)="onSigTouchMove($event, field)"
                    (touchend)="onSigEnd(field)">
                  </canvas>
                  <button type="button" class="sig-clear" (click)="clearSignature(field)">
                    <i class="fa-solid fa-eraser"></i> Limpiar
                  </button>
                </ng-container>
                <ng-container *ngIf="mode === 'preview'">
                  <div class="field-preview-placeholder">
                    <i class="fa-solid fa-signature"></i>
                    <span>Firma</span>
                  </div>
                </ng-container>
                <ng-container *ngIf="mode === 'readonly'">
                  <img *ngIf="getFieldControl(field).value" [src]="getFieldControl(field).value" class="signature-img" alt="Firma" />
                  <span *ngIf="!getFieldControl(field).value" class="sig-empty">Sin firma</span>
                </ng-container>
              </div>

              <!-- Validation Error -->
              <small *ngIf="isInvalid(field)" class="error-message">
                {{ getErrorMessage(field) }}
              </small>
            </div>
          </div>
        </ng-container>

      </ng-container>

      <!-- Table Fields -->
      <ng-container *ngIf="field.Field_Type === 'table' && getTableColumns(field).length > 0">
        <div class="table-full-width">
          <div class="table-label">
            {{ field.Label }}
            <span *ngIf="field.Required" class="required-mark">*</span>
          </div>
          <div class="table-field-area">
              <table class="form-table">
                <thead>
                  <tr>
                    <th *ngFor="let col of getTableColumns(field)">{{ col.name }}</th>
                    <th *ngIf="mode === 'fill'" class="th-actions"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of getTableRows(field); let ri = index; trackBy: trackByIndex">
                    <td *ngFor="let col of getTableColumns(field); trackBy: trackByIndex">
                      <ng-container *ngIf="mode === 'fill'">
                        <input *ngIf="col.type === 'text_short' || col.type === 'select' || col.type === 'number'"
                          [type]="col.type === 'number' ? 'number' : 'text'"
                          class="table-cell-input"
                          [value]="row[col.name] ?? ''"
                          (blur)="setCellValue(field, ri, col.name, $event)" />
                        <input *ngIf="col.type === 'boolean'"
                          type="checkbox" class="table-cell-checkbox"
                          [checked]="!!row[col.name]"
                          (change)="setCellChecked(field, ri, col.name, $event)" />
                      </ng-container>
                      <ng-container *ngIf="mode !== 'fill'">
                        <span *ngIf="col.type !== 'boolean'">{{ row[col.name] || '—' }}</span>
                        <span *ngIf="col.type === 'boolean'" class="table-bool-display">{{ row[col.name] ? '&#9745;' : '&#9744;' }}</span>
                      </ng-container>
                    </td>
                    <td *ngIf="mode === 'fill'" class="td-actions">
                      <button type="button" class="table-row-remove" (click)="removeTableRow(field, ri)"
                        [disabled]="getTableRows(field).length <= 1">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <button *ngIf="mode === 'fill'" type="button" class="table-add-row" (click)="addTableRow(field)">
                <i class="fa-solid fa-plus"></i> Agregar fila
              </button>
          </div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
